// extracted by mini-css-extract-plugin
export default {"list":"orders-list_list__FhHl5"};